import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import './themes/styles.scss';
import App from './App';

import storeConfig from './store/storeConfig';

const store = storeConfig();

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);
